import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { SortBy, State, FilterBy } from './types';

export const getInitialState = () => ({
  eventHubPages: {},
  isLoading: false,
  searchTerm: '',
  currentPage: 1,
  eventHubPagesPerPage: 25,
  eventHubPagesCount: 0,
  sortBy: SortBy.CreatedDateAscending,
  filterBy: FilterBy.AllPages
});

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
